import { render, staticRenderFns } from "./OrderStatusFilter.vue?vue&type=template&id=b3acb08a"
import script from "./OrderStatusFilter.vue?vue&type=script&lang=js"
export * from "./OrderStatusFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports